module.exports = __webpack_public_path__ + "img/ulisboa-logo.39f44030.png";